  import { Component } from '@angular/core';
  import { IonicPage, NavController, NavParams,Events,LoadingController,ActionSheetController ,AlertController} from 'ionic-angular';
  import {CommonProvider} from "../../providers/common/common";
  import  $ from 'jquery';
  import {ThankuPage} from '../thanku/thanku'
  import * as CryptoJS from 'crypto-js';
  import {GenericFormValidationProvider} from "../../providers/common/form-validation"
  import { HomePage } from '../home/home';
  // import { AllInOneSDK } from '@ionic-native/all-in-one-sdk/ngx';
  // import WLCheckout from "../../../weipl-checkout-cordova-master/www/WEIPL_checkout";
  import { AllInOneSdkProvider } from '../../providers/all-in-one-sdk/all-in-one-sdk'

  declare let WLCheckout:any;
  declare let window:any;
  declare var $:any;
  /**
   * Generated class for the OdpaymentPage page.
   *
   * See https://ionicframework.com/docs/components/#navigation for more info on
   * Ionic pages and navigation.
   */

  @IonicPage()
  @Component({
    selector: 'page-odpayment',
    templateUrl: 'odpayment.html',
  })
  export class OdpaymentPage {
    odpaymentArr:any=[];
    totalAmount:any=0;
    // totalAmount:any=0;
    errorDisplay:any={};
    token:any=""
    checkTotalAmount:any=0;
    constructor(private loadingCtrl:LoadingController,
      private fv : GenericFormValidationProvider,
      private events:Events,public navCtrl: NavController,
      public navParams: NavParams,private cp: CommonProvider,
      public actionSheetCtrl: ActionSheetController,
      private allInOneSdk : AllInOneSdkProvider,
      private alertCtrl:AlertController
      // private allInOneSDK:AllInOneSDK
      ) {
    }
    ionViewDidLoad() {
      
      this.odpaymentArr = this.navParams.data.paymentMode;
      ////console.log('ionViewDidLoad OdpaymentPage',this.odpaymentArr);
      this.odpaymentArr.forEach((res:any)=>{
        this.totalAmount=parseInt(this.totalAmount)+parseInt(res.chargeamt)
        this.checkTotalAmount=parseInt(this.checkTotalAmount)+parseInt(res.chargeamt)
      })
      this.totalAmount=this.totalAmount;
      var loan = localStorage.getItem("cc");
      let loading = this.loadingCtrl.create({
            content: 'Please wait...'
          });
      this.cp.generateToken(loading,loan).then((res:any)=>{
          // loading.dismiss()
        var res=JSON.parse(res)
        this.token=res.TokenKey;

      }) 
  // this.goToPaymentsEmi()


    }
paytmPayment(orderId,txnToken,amount){ 

    var that=this;
        var config = {
        "root": "",
        "flow": "DEFAULT",
        "data": {
        "orderId": orderId, //"", /* update order id */
        "token": txnToken, /* update token value */
        "tokenType": "TXN_TOKEN",

        "amount": amount, /* update amount */
        "isStaging": false,
        },
        "merchant": {
            "mid": "INDIAB40518225417073",//"INDIAB24704503981786",

        },
        "handler": {
          
          
          notifyMerchant:function notifyMerchant(eventName,data){
            // //console.log("notify merchant about the payment state",data,eventName);
            if(eventName=='APP_CLOSED'){
              let responsePaytm:any={};
              responsePaytm.paytmaction = 'APP_CLOSED';
              that.updateTransaction(JSON.stringify( responsePaytm),'PAYTMWEB')
            }
          } 
        }
        };

  
        //console.log(window.Paytm);
        if(window.Paytm && window.Paytm.CheckoutJS){
             window.Paytm.CheckoutJS.init(config).then(function onSuccess() {
               
             window.Paytm.CheckoutJS.invoke();
        }).catch(function onError(error){
             
        });
        
    }

  }


    techprocessPaymentGateway(){
   this.errorDisplay=this.fv.checkValidationFormAllControls(document.forms[0],true,[]);
       
      if(this.errorDisplay.valid){
        return false;
      }else if(!this.totalAmount && this.totalAmount<=0){
          return false;
      }else{
        let loading = this.loadingCtrl.create({
            content: 'Please wait...'
          });

        let request:any={
              "Amount":this.totalAmount,
              "LanNo":localStorage.getItem("cc"),
              "Scheme":"",
              "PartPaymentEffect":"",
              "Payment_Source":"TECHPROCESSWEB",
              "Userid":localStorage.getItem("mobile"),
              "version":this.cp.VERSION,
              "platform":this.cp.PLATFORM
            }
            loading.present()
           this.cp.createPaymentTrasaction(loading,request,this.token).then((resp:any)=>{
                    loading.dismiss()
                    if(JSON.parse(resp).Message == 'FAILURE'){
                      this.displayAlert(JSON.parse(resp).Displaymessage,"Error")
                      return false;
                    }else{
                      
                   var that = this;
                   var txn= JSON.parse(resp).Data[0].clnt_txn_ref;//new Date().getTime();
                    localStorage.setItem("localPaymentResponce",JSON.stringify(resp))
                          //loading.present();
                          ////console.log(this.totalAmount);
                          // ////console.log(txn,"amount:",this.totalAmount);
                          var token="L1520|"+txn+"|"+this.totalAmount+"||||||||||||||4365446291ODRDJU"
                          var hashPwd = CryptoJS.SHA512(token).toString(CryptoJS.enc.Hex);
                          ////console.log(hashPwd);
                   
                           var options = {
                    "features": {
                                'showPGResponseMsg': true,
                                'enableExpressPay': false,
                                'siDetailsAtMerchantEnd': false,
                                'enableSI': false,
                                'payDetailsAtMerchantEnd': false,
                                "enableNewWindowFlow": false 
                              },
                    "consumerData": {
                      "deviceId": this.cp.deviceTypePayment, //supported values "ANDROIDSH1" or "ANDROIDSH2" for Android, supported values "iOSSH1" or "iOSSH2" for iOS and supported values "WEBSH1" or "WEBSH2" for Browser
                      "token": hashPwd,
                      "returnUrl": this.cp.commonApiUrl+'/redirect',
                      "paymentMode": "all",
                      "merchantLogoUrl": "https://www.paynimo.com/CompanyDocs/company-logo-vertical-light.png",  //provided merchant logo will be displayed
                      "merchantId": "L1520",
                      "currency": "INR",
                       
                      "txnId": txn,   //Unique merchant transaction ID
                      "items": [{
                        "itemId": "IHFL_LOAN",
                        "amount": this.totalAmount,
                        "comAmt": "0"
                      }],
                      "customStyle": {
                        "PRIMARY_COLOR_CODE": "#45beaa",   //merchant primary color code
                        "SECONDARY_COLOR_CODE": "#FFFFFF",   //provide merchant's suitable color code
                        "BUTTON_COLOR_CODE_1": "#2d8c8c",   //merchant's button background color code
                        "BUTTON_COLOR_CODE_2": "#FFFFFF"   //provide merchant's suitable color code for button text
                      }
                    }
                  };
                    var paymentCallback = function(response) {
                      that.updateTransaction(JSON.stringify( response),'TECHPROCESSWEB')
                    }
                    var errorCallback = function(error) {
                      this.displayAlert(JSON.stringify( error),"Error")
                       
                    }
                    try{

                       $.pnCheckout(options);
                         
                    }catch(err){
                       
                    }
                     
                    }
           })
         
    



          }


    }
    updateTransaction(resonce,type){
     let loading = this.loadingCtrl.create({
          content: 'Please wait...'
        });
         
      this.cp.updatePayment(loading,resonce,type,this.token).then((res:any)=>{
        this.navCtrl.setRoot(ThankuPage, {data:JSON.stringify(res),"action":JSON.stringify(resonce),replaceUrl:true});
      })


    }
   displayAlert(msg,title){
      let masg=msg
      const alert = this.alertCtrl.create({
        title: title,
        subTitle: masg,
        buttons: ['OK']
      });
      alert.present();
   } 
   showAlert(res) {

      let masg="<p>"+JSON.parse(res).Message+"</p><br />"+JSON.parse(res).Message+"Transaction Id : "+JSON.parse(res).transctionId+"<br />Date : "+JSON.parse(res).date
      const alert = this.alertCtrl.create({
        title: res.title,
        subTitle: masg,
        buttons: ['OK']
      });
      alert.present();
    }
    presentActionSheet() {
      // ////console.log(this.allInOneSDK,"this.allInOneSDK")


 
//Call Initiate Transaction API from your backend to generate Transaction Token.



      this.errorDisplay=this.fv.checkValidationFormAllControls(document.forms[0],true,[]);
      ////console.log(this.errorDisplay);
      if(this.errorDisplay.valid){
         this.displayAlert("Please enter the amount","")
        return false;
      }else if(!this.totalAmount && this.totalAmount<=0){
          this.displayAlert("Please enter the amount","");
          return false;
      }else if(this.totalAmount<10){
          this.displayAlert("Amount should be at from 10 to "+this.checkTotalAmount,"");
          return false;
      }else if(this.totalAmount>this.checkTotalAmount){
          this.displayAlert("Amount should be at from 10 to "+this.checkTotalAmount,"");
          return false;
      }

      else{
          const actionSheet = this.actionSheetCtrl.create({
        title: '',
        cssClass: 'notcomman',
        buttons: [
          {
            text: 'Paytm',
            role: 'destructive',
            handler: () => {
              this.goToPaymentsEmi()
            }
          },{
            text: 'Techprocess',
            handler: () => {
               this.techprocessPaymentGateway()
            }
          }
        ]
      });
      actionSheet.present();
      }
    
    }
    goToPaymentsEmi(){
     
          let loading = this.loadingCtrl.create({
            content: 'Please wait...'
          });
          loading.present()
          // this.totalAmount=this.totalAmount;
            this.errorDisplay=this.fv.checkValidationFormAllControls(document.forms[0],true,[]);
            ////console.log(this.errorDisplay);
            if(this.errorDisplay.valid){
              return false;
            }else if(!this.totalAmount && this.totalAmount<=0){
                return false;
            }else{
           var orderid=""
            
            orderid="ORDERID_"+new Date().getTime();
          
            let request:any={
              "Amount":this.totalAmount,
              "LanNo":localStorage.getItem("cc"),
              "Scheme":"",
              "PartPaymentEffect":"",
              "Payment_Source":"PAYTMWEB",
              "Userid":localStorage.getItem("mobile"),
              "version":this.cp.VERSION,
              "platform":this.cp.PLATFORM
            }
             
             
                 this.cp.createPaymentTrasaction(loading,request,this.token).then((resp:any)=>{
                  var orderid=""
                  orderid=JSON.parse(resp).Data[0].clnt_txn_ref;
                   
                  this.cp.newPaytmPayment(loading,orderid,this.totalAmount).then((res:any)=>{
                      loading.dismiss()
                    ////console.log(JSON.parse(resp))
                    if(JSON.parse(resp).Message == 'FAILURE'){
                      this.displayAlert(JSON.parse(resp).Displaymessage,"")
                      return false;
                    }else{
                        localStorage.setItem("localPaymentResponce",JSON.stringify(resp))
                       // this.onScriptLoad(orderid,JSON.parse(res).body.txnToken,this.totalAmount)
                       this.paytmPayment(orderid,JSON.parse(res).body.txnToken,this.totalAmount)
                    }
                    
                        
                 })

             
          
            
          })

    }        


  }

   

  }



// WEBPACK FOOTER //
// ./src/pages/odpayment/odpayment.ts